import { useMemo } from 'react';

export function useFormMemoDefaultValues<E>(defaultValues: E) {
  return useMemo(() => defaultValues, [defaultValues]);
}
